module.exports = "/_next/static/images/advantages-man-d13bc59173362e1b9f38b1f24d0a8f88.svg";